module.exports = "/img/24.312c80.webp";